import { Button, Layout } from 'antd'
import React from 'react'
import _ from 'lodash'
import { use } from 'xadmin'
import { _t } from 'xadmin-i18n'
import { ModelBlock } from 'xadmin-model'
import { C, Icon, Page, Loading } from 'xadmin-ui'
import './index.css'

const { Content, Sider } = Layout

const DefaultAddButton = ({ onAdd, children }) => (
  <Button type="primary" onClick={onAdd}>{children}</Button>
)

const ModelListPage = ({ location }) => {
  const { model } = use('model')
  const { canAdd } = use('model.permission')
  const { onAdd } = use('model.event')

  const ItemsComponent = (model.components && model.components.DataList) || C('Model.DataTable')
  const query = location && location.query

  let icon = model.icon || model.name
  if(_.isString(icon)) {
    icon = <Icon name={icon}/>
  }
  const title = model.title

  const renderActions = () => {
    const AddButton = (model.components && model.components.AddButton) || C('Model.AddButton') || DefaultAddButton
    return (<>
      <ModelBlock name="model.list.navbtn" />
      { canAdd ?
        (<AddButton onAdd={onAdd}><Icon name="plus"/> {_t('Add {{object}}', { object: model.title })}</AddButton>) : null
      }
    </>)
  }

  const GridComponents = [
    <div key="model-list-subnav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.5rem' }}>
      <C is="Model.Pagination" />
      <C is="Model.ListSubMenu" />
    </div>,
    <ItemsComponent key="model-list-grid" query={query} />,
    <div key="model-list-downnav" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.5rem' }}>
      <C is="Model.ActionBar" />
      <C is="Model.Pagination" />
    </div>
  ]
  
  return (
    <ModelBlock name="model.list.sidemenu" >
      { sideMenu => (
        <Page className={`xadmin-model-list-${model.key}`} 
          title={(<span>{icon} {title}</span>)} 
          sider={sideMenu}
          subTitle={<ModelBlock name="model.list.nav" />}
          actions={renderActions()}>
          <ModelBlock name="model.list.submenu" />
              <ModelBlock name="model.list.sidepanel" >
                { sidePanel => sidePanel ? (
                  <Layout>
                    <Content>{GridComponents}</Content>
                    { sidePanel ? <Sider width={200} style={{ backgroundColor: 'transparent', marginLeft: '.5rem' }}>{ sidePanel }</Sider> : null  }
                  </Layout>
                ) : GridComponents }
              </ModelBlock>
        </Page>
      ) }
    </ModelBlock>
  )
}

const ModelFormPage = ({ params, location: { query } }) => {
  const { model } = use('model')
  const { onSaved } = use('model.event')
  const { data, loading } = use('model.item', { id: params && params.id })

  const title = params && params.id ? _t('Edit {{title}}', 
    { title: model.title + ' ' + (data && data[model.displayField || 'name'] || '') }) : _t('Create {{title}}', { title: model.title })
  const FormComponent = (model.components && model.components.DataForm) || C('Model.DataForm')

  return (
    <Page className={`xadmin-model-form-${model.key}`} 
      title={title} onBack={()=>history.back()}
      subTitle={<ModelBlock name="model.edit.nav" />}
      actions={<ModelBlock name="model.edit.navbtn" />}>
      <ModelBlock name="model.form.before" />
      { loading ? <Loading /> : <FormComponent id={params && params.id} item={data} query={query} onSubmitSuccess={onSaved} /> }
      <ModelBlock name="model.form.after" />
    </Page>
  )
}

const ModelDetailPage = ({ params, hideEditBtn }) => {
  const { model } = use('model')

  const renderActions = () => {
    const { canEdit } = use('model.permission')
    const { onEdit } = use('model.event')

    return (<>
      <ModelBlock name="model.detail.navbtn" />
      {canEdit && !hideEditBtn ? // 工作表权限
        (<Button type="primary" onClick={()=>onEdit(params && params.id)}><Icon name="edit"/> {_t('Edit')}</Button>) : null
      }
    </>)
  }

  const DetailComponent = (model.components && model.components.DataDetail) || C('Model.DataDetail')

  return (
    <Page className={`xadmin-model-detail-${model.key}`} 
      title={model.title} onBack={()=>history.back()}
      subTitle={<ModelBlock name="model.detail.nav" />}
      actions={renderActions()}>
      <ModelBlock name="model.detail.before" />
      <DetailComponent id={params && params.id} />
      <ModelBlock name="model.detail.after" />
    </Page>
  )
}

export { ModelListPage, ModelFormPage, ModelDetailPage }

